import Vue from 'vue'
import VueNativeSock from 'vue-native-websocket'
import { getApiBaseUrl } from '@/helpers/network'

export function setSocket(vue) {
    if (vue.$disconnect) vue.$disconnect()
    let index = Vue._installedPlugins.indexOf(VueNativeSock)
    if (index > -1) {
        Vue._installedPlugins.splice(index, 1)
    }
    Vue.use(VueNativeSock, `${getApiBaseUrl('sockets')}`, {
        format: 'json',
        connectManually: true,
        reconnection: true
    })
    vue.$connect()
}
